import { render, staticRenderFns } from "./ProcessCateEdit.vue?vue&type=template&id=dd1aba30&scoped=true"
import script from "./ProcessCateEdit.vue?vue&type=script&lang=js"
export * from "./ProcessCateEdit.vue?vue&type=script&lang=js"
import style0 from "./ProcessCateEdit.vue?vue&type=style&index=0&id=dd1aba30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1aba30",
  null
  
)

export default component.exports